import { useSelector } from "react-redux";
import { getAuthorizationToken } from "store/features/authorization";

export const useHeaders = (params?: HeadersInit) => {
    const token = useSelector(getAuthorizationToken);

    return {
        ...params,
        Authorization: `Bearer ${token}`,
    };
};
